module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/batch-links/batch-links.component.css
// module id = ./src/app/Screens/batch-links/batch-links.component.css
// module chunks = main